module.exports = __webpack_public_path__ + "44c0b7c7ad8ea3e9bbbd4ea669db686d.jpg";